var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-collapse',[_c('app-collapse-item',{attrs:{"is-visible":true,"title":_vm.label}},[_c('textarea',{ref:"editorTextarea",staticStyle:{"min-height":"600px","width":"100%"},attrs:{"id":"SunEditorTextArea"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }